import React from "react";
import "./ModalStyles.scss";
import img from "../../../assets/delete.png";
import Button from "../../button/Button";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className='modal-overlay' onClick={onClose}>
      <div className='modal-content' onClick={(e) => e.stopPropagation()}>
        <div className='header'>Access Denied</div>
        <div className='err-cont'>
          <img alt='' src={img} className='error' />
        </div>
        <div className='content'>
          You attempted to access a page or resource that requires higher
          privileges or specific permissions. Unfortunately, your current user
          account does not have the necessary rights to proceed.
        </div>
        <div className='btn-container'>
          <Button text='Close' onClick={onClose} />
        </div>
      </div>
    </div>
  );
};

export default Modal;
